// Page: thank-you-message  (thank-you/message "utility assistance" panel)
//
// Ported from the inline <script> in
//   Enrollment_modules/thank-you/message.module/module.html
//
// DELIBERATE CHANGES (behaviour-preserving):
//   1. `#utility_display_name` lookup scoped to `root` (was document.querySelector).
//   2. The UpdateDealRecord fetch is ROOT-RELATIVE via core/api `apiUrl`
//      (was hardcoded https://enrollment.nautilussolar.com).
//
// DEAD CODE carried over faithfully: `addDataToDealRecord` is defined but never
// called anywhere (no caller on this page, no sibling reference) — kept and
// `void`-referenced, mirroring the pilot's treatment of `openPopuppfIl`. Safe to
// delete in the deep-refactor pass.
//
// The sibling thank-you-lmi/message module's only script was a commented-out
// `getEmail()` call — dead, so that module needs no page module.

import { apiUrl } from "../../core/api"
import * as storage from "../../core/storage"

export function init(root: HTMLElement): void {
__ea_trace("modules/shared/thank-you-message.ts","init",[root],["root"]);
  function UtilityDisplayName(): void {
__ea_trace("modules/shared/thank-you-message.ts","UtilityDisplayName",[],[]);
    // localStorage.getItem returns null if the key doesn't exist (e.g. user
    // landed on this page without completing prior steps), so guard before
    // parsing to avoid "null is not an object" errors.
    const raw = storage.get("UtilitySessionDetails")
    if (!raw) return
    const SessionLocalStorage = JSON.parse(raw)
    const el = root.querySelector("#utility_display_name")
    // The element may not be present on all page variants, so guard before setting text.
    if (el && SessionLocalStorage["6"] !== "") {
      el.textContent = SessionLocalStorage["6"]
    }
  }
  UtilityDisplayName()

  // Defined but never invoked in the original — preserved for faithfulness.
  async function addDataToDealRecord(): Promise<boolean> {
__ea_trace("modules/shared/thank-you-message.ts","addDataToDealRecord",[],[]);
    const dealId = storage.get("dealId")
    try {
      const data = {
        properties: {
          deal_id: dealId,
          skip_usage_submission: "Yes",
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })

      if (response.ok) {
        // (original had an empty success branch)
      }
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  void addDataToDealRecord
}
